import React from 'react';

import classNames from 'classnames/bind';
import style from './PagePreview.scss';
const ctx = classNames.bind(style);

import Title from '../Title';
import Spreader from '../Spreader';
import ReadMoreLink from '../ReadMoreLink';
import Sticker from '../Sticker';
import Scalable from '../Scalable';

import truncate from 'truncate';

class PagePreview extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isFullDescription: !props.limitDescription,
    };
  }

  toggleDescription = event => {
    const { isFullDescription } = this.state;

    this.setState({
      isFullDescription: !isFullDescription,
    });
  };

  renderLimitedDescription(text) {
    const { limitDescription } = this.props;

    const limitedText = truncate(text, limitDescription);

    return (
      <span>
        <span className={ctx('description-text')}>{limitedText}</span>
        <span className={ctx('expand-link')} onClick={this.toggleDescription}>
          Развернуть
        </span>
      </span>
    );
  }

  render() {
    const {
      limitDescription,
      title,
      description,
      image,
      sticker,
      link,
    } = this.props;
    const { isFullDescription } = this.state;

    return (
      <div>
        <Spreader>
          <Title text={title} />
          <div className={ctx('description')}>
            {isFullDescription
              ? description
              : this.renderLimitedDescription(description)}
          </div>
        </Spreader>
        <Spreader isDisappear>
          <Scalable>
            <img width="100%" src={image} />
          </Scalable>
        </Spreader>
        <Spreader isWide>
          <Sticker>{sticker}</Sticker>
        </Spreader>
        <Spreader>
          <div className={ctx('read-more')}>
            <ReadMoreLink title="Прочитать полностью" link={link} isInternal />
          </div>
        </Spreader>
      </div>
    );
  }
}

export default PagePreview;
